/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".loading-custom[_ngcontent-%COMP%]{border:1px solid #e0e0e0;display:block;padding:10px}"];
export { styles as styles };
